import React from 'react';

function Select({ className = '', ...props }) {
  return (
    <select
      className={`h-10 px-3 rounded-lg border border-[var(--axial-border)] bg-[var(--axial-surface)] text-[var(--axial-text-primary)] focus:outline-none focus:ring-2 focus:ring-[var(--axial-primary)] ${className}`}
      {...props}
    />
  );
}

export default Select;
